module.exports = __webpack_public_path__ + "img/image-9.ed32eb0d.jpeg";